import { HistoryItem, ResourceType } from "@common/types/auditLog";
import { HistoryRow } from "@components/history/views/historyViewConfig";
import { historyItemToRow } from "@components/history/utils/historyItemToRow";

export interface OrganizationActivityRow extends HistoryRow {
    workspaceId?: string;
    clientWorkspaceIds: string[];
}

const ORGANIZATION_MEMBER_RESOURCE_TYPES: readonly ResourceType[] = [
    ResourceType.ORGANIZATION_MEMBER,
    ResourceType.ORGANIZATION_INVITE,
];

export function isOrganizationMemberActivity({
    resourceType,
}: Pick<OrganizationActivityRow, "resourceType">): boolean {
    return ORGANIZATION_MEMBER_RESOURCE_TYPES.includes(resourceType);
}

export function toOrganizationActivityRow(
    item: HistoryItem,
): OrganizationActivityRow {
    const id = [
        item.date,
        item.sourceType,
        item.resourceType,
        item.actorId ?? "system",
        item.changeTypes.join(","),
        item.fields.join(","),
        item.workspaceId ?? "organization",
        item.resourceIds.join("-"),
    ].join(":");

    return {
        ...historyItemToRow({ item, id }),
        workspaceId: item.workspaceId,
        clientWorkspaceIds: item.clientWorkspaceIds ?? [],
    };
}
